import { useState } from "react";
import Dashboard from "../../../Dashboard";
import AppSidebar, { SB_W, SB_W_COLLAPSED } from "../../../AppSidebar";
import "../../../V2SideDrawer.css";
import "../styles/DashboardViewV2Page.css";

export default function DashboardViewV2Page({ showToast, user }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    () => localStorage.getItem("sb-collapsed") === "true"
  );

  return (
    <div
      className="dbv2-root"
      style={{ gridTemplateColumns: sidebarCollapsed ? `${SB_W_COLLAPSED} 1fr` : `${SB_W} 1fr` }}
    >
      <AppSidebar
        user={user}
        collapsed={sidebarCollapsed}
        onCollapse={() => setSidebarCollapsed((c) => {
          const next = !c;
          localStorage.setItem("sb-collapsed", String(next));
          return next;
        })}
      />

      <div className="dbv2-main">
        <Dashboard showToast={showToast} user={user} />
      </div>
    </div>
  );
}
